import {
  CalendarIcon,
  CircleHelpIcon,
  FileTextIcon,
  HouseIcon,
  LinkIcon,
  SettingsIcon,
  ShoppingBagIcon,
  TrendingUpIcon,
  UsersIcon,
} from 'lucide-react';

// One list for the main sidebar and the rail beside a page's sidebar, so a new section shows in both.
export const MAIN_SECTIONS = [
  { key: 'dashboard', to: '/', label: 'Dashboard', Icon: HouseIcon, exact: true },
  {
    key: 'checkouts',
    to: '/checkouts',
    label: 'Storefront',
    listLabel: 'Checkout pages',
    Icon: ShoppingBagIcon,
    subItems: [
      { to: '/payments', label: 'Payments' },
      { to: '/subscriptions', label: 'Subscriptions' },
    ],
  },
  {
    key: 'events',
    to: '/events',
    label: 'Event ticketing',
    listLabel: 'Events',
    Icon: CalendarIcon,
    subItems: [{ to: '/bookings', label: 'Bookings' }],
  },
  {
    key: 'forms',
    to: '/forms',
    label: 'Form builder',
    listLabel: 'Forms',
    Icon: FileTextIcon,
    subItems: [{ to: '/submissions', label: 'Submissions' }],
  },
  {
    key: 'linkInBio',
    to: '/link-in-bio',
    label: 'Link in bio',
    listLabel: 'Edit',
    badge: 'New',
    Icon: LinkIcon,
    subItems: [
      { to: '/link-in-bio/analytics', label: 'Analytics' },
      { to: '/link-in-bio/settings', label: 'Settings' },
    ],
  },
  { key: 'customers', to: '/customers', label: 'Customers', Icon: UsersIcon },
  { key: 'coupons', to: '/coupons', label: 'Coupons', Icon: TrendingUpIcon },
  { key: 'settings', to: '/settings', label: 'Store settings', Icon: SettingsIcon },
  { key: 'docs', href: '/docs', label: 'Knowledge base', Icon: CircleHelpIcon },
];
